import {isFleetConfigEnabled} from '../api/fleet-config'
import {useFleetConfigKeyQuery} from '../query/fleet-config'
import {FleetConfigKeysType} from '../store/state/config/state'
import {useHasActiveVessels} from './vessels'

export function useIsOtsmOnlyEnv(): boolean {
    const {data: otsmConfig} = useFleetConfigKeyQuery(FleetConfigKeysType.LICENSE_OTSM)
    const isOtsmOnly = isFleetConfigEnabled(otsmConfig)
    const hasActiveVessel = useHasActiveVessels()

    return isOtsmOnly && !hasActiveVessel
}
